
function showNew(){
  $('.address .hidden').slideUp()
  $('#add_new_address').addClass('active')
  $('#add_new_address .hidden').slideDown()
  if ($('.address').hasClass('active')) {
    $('.address').removeClass('active')
    $('.address .hidden').slideUp()
    $(`.address .block`).slideDown()
  }
}

function cancelForm (){
  if ($('#add_new_address').hasClass('active')) {
    $('#add_new_address').removeClass('active')
    $('#add_new_address .hidden').slideUp()
  }
  if ($('.address').hasClass('active')) {
    $('.address').removeClass('active')
    $('.address .hidden').slideUp()
    $(`.address .block`).slideDown()
  }
}


function showEdit (id) {
  if ($('#add_new_address').hasClass('active')) {
    $('#add_new_address').removeClass('active')
    $('#add_new_address .hidden').slideUp()
  }
  if ($('.address').hasClass('active')) {
    $('.address').removeClass('active')
    $('.address .hidden').slideUp()
    $(`.address .block`).slideDown()
  }
  $(`.address[data-id=${id}] .hidden`).slideDown()
  $(`.address[data-id=${id}] .block`).slideUp()
  $(`.address[data-id=${id}]`).addClass('active')
}
const init = () => {
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {hideElement: 'AddressProvinceContainerNew'});

  let addresses = document.querySelectorAll('.address')

  addresses.forEach(address => {
    let id = address.dataset.id
    new Shopify.CountryProvinceSelector(`AddressCountry_${id}`, `AddressProvince_${id}`, {hideElement: `AddressProvinceContainer_${id}`});
  })

  let edit_buttons = document.querySelectorAll('.edit')
  edit_buttons.forEach(button => {
    let id = button.dataset.id
    button.addEventListener('click', () => {
      showEdit(id)
    })
  });

  $('.cancel').click(cancelForm)
  $('#add_new_address .add').click(showNew)
}

export default init
